const C = {
  ObfuscationSeed: "82f2ceed4c503896c8a291e560bd4325",
  RoleAdmin: "ADMIN",
  RoleBrokerAdmin: "BROKERAGE_ADMIN",
  RoleLenderAdmin: "LOAN_OFFICE_ADMIN",
  RoleAgent: "AGENT",

  AGENT_DOMAINS: [
    // "localhost",
    "agents.primestreet.io",
    "devagents.primestreet.io",
  ],
  BROKER_DOMAINS: ["brokers.primestreet.io", "devbrokers.primestreet.io"],

  // CTA text shown on blurred widgets
  REFERRAL_PROGRESSION_CTA_TEXT:
    "IRIS customers can track the performance of every lead they generate. This widget shows a breakdown of each lead’s progress in the pipeline. Inquire today to learn more about this data!",
  LEADS_BY_SOURCE_CTA_TEXT:
    "IRIS customers can track every source they’re generating leads with. This widget shows how the investment you’re making on each lead source is performing compared to others. Inquire today to learn more about this data!",
  LEADS_BY_STATUS_CTA_TEXT:
    "IRIS customers can track how many leads their sources have generated for them this quarter. Inquire today to learn more about this data!",
  LEADS_LIMITS_CTA_TEXT:
    "IRIS customers can see the distribution of leads they’ve generated across each stage  to make more accurate forecasting. Inquire today to learn more about this data!",

  // CTA widget description text that is shown on the dialog that pops up when Learn More clicked
  // Currently it's all the same text, but since it was built to be dynamic for each widget, we will keep it this way in case things change
  REFERRAL_PROGRESSION_CTA_DESCRIPTION:
    "IRIS can save you time and help you get better returns on your lead spend. Click below to have a Lead Expert contact you.",
  LEADS_BY_SOURCE_CTA_DESCRIPTION:
    "IRIS can save you time and help you get better returns on your lead spend. Click below to have a Lead Expert contact you.",
  LEADS_BY_STATUS_CTA_DESCRIPTION:
    "IRIS can save you time and help you get better returns on your lead spend. Click below to have a Lead Expert contact you.",
  LEADS_LIMITS_CTA_DESCRIPTION:
    "IRIS can save you time and help you get better returns on your lead spend. Click below to have a Lead Expert contact you.",

  GOOGLE: {
    USER_ID: "userId",
    USER_UUID: "dimension1",
    USER_NAME: "dimension2",
    BROKERAGE_ID: "dimension3",
    BROKERAGE_NAME: "dimension4",
    USER_ROLE: "dimension5",
  },
  ROLE_TYPE: {
    PRIMESTREET_ROLE: "PRIMESTREET_ROLE",
    LOAN_OFFICE_ROLE: "LOAN_OFFICE_ROLE",
    BROKER_ROLE: "BROKER_ROLE",
  },
  ROLE: {
    ADMIN: "ADMIN",
    BROKERAGE_ADMIN: "BROKERAGE_ADMIN",
    AGENT: "AGENT",
    MANAGER: "MANAGER",
    CSR_SUPERVISOR: "CSR_SUPERVISOR",
    CSR: "CSR",
    CSR_VIEW_OPPORTUNITIES: "CSR_VIEW_OPPORTUNITIES",
    AGENT_ENGAGEMENT: "AGENT_ENGAGEMENT",
    QA_TEAM: "QA_TEAM",
    // not in use //
    DS_TEAM: "DS_TEAM",
    APP_DEV: "APP_DEV",
    CONTACT_CENTER: "CONTACT_CENTER",
    AGENT_UPDATER: "AGENT_UPDATER",
    AGENT_CHANGE_CONSUMER: "AGENT_CHANGE_CONSUMER",
    REFERRAL_TEAM: "REFERRAL_TEAM",
    REFERRAL_CREATOR: "REFERRAL_CREATOR",
    OPPORTUNITY_CREATOR: "OPPORTUNITY_CREATOR",
    LEAD_SUPPLIER: "LEAD_SUPPLIER",
    INTERACTION_USER: "INTERACTION_USER",
    USER_PROFILE_READER: "USER_PROFILE_READER",
    USER_CHANGE_CONSUMER: "USER_CHANGE_CONSUMER",
    WORKFLOW_EVENT_CREATOR: "WORKFLOW_EVENT_CREATOR",
    TASK_EXECUTOR: "TASK_EXECUTOR",
    LOG_CREATOR: "LOG_CREATOR",
    EXAMPLE_STREAM_PROCESSOR: "EXAMPLE_STREAM_PROCESSOR",
    LOAN_OFFICE_ADMIN: "LOAN_OFFICE_ADMIN",
    APINATION_INTEGRATION: "APINATION_INTEGRATION",
  },
  ROLE_DEFAULT_ROUTE: {
    ADMIN: "/console/brokerages",
    MANAGER: "/console/brokerages",
    QA_TEAM: "/console/brokerages",
    CSR_SUPERVISOR: "/console/brokerages",
    AGENT_ENGAGEMENT: "/console/brokerages",
    BROKERAGE_ADMIN: "/console",
    CSR: "/console",
    CSR_VIEW_OPPORTUNITIES: "/console/opportunities",
    AGENT: "/console/agent-followups",
  },
  REFERRAL_STATUS: {
    AWAITING_FOLLOWUP: "AWAITING_FOLLOWUP",
    SPOKEN_WITH: "SPOKEN_WITH",
    SHOWN_HOMES: "SHOWN_HOMES",
    MET_WITH_SELLER: "MET_WITH_SELLER",
    OFFER_MADE: "OFFER_MADE",
    LISTED_HOME: "LISTED_HOME",
    UNDER_CONTRACT: "UNDER_CONTRACT",
    CLOSED: "CLOSED",
    LEASED: "LEASED",
    LONG_TERM_HOLD: "LONG_TERM_HOLD",
    REMOVED: "REMOVED",
  },
  OPPORTUNITY_STATUS: {
    CONTACT_NOT_ESTABLISHED: "CONTACT_NOT_ESTABLISHED",
    CONTACT_ESTABLISHED: "CONTACT_ESTABLISHED",
    ASSIGNED_TO_AGENT: "ASSIGNED_TO_AGENT",
    CLOSED: "CLOSED",
    REMOVED_ASSIGNMENT_TO_AGENT: "REMOVED_ASSIGNMENT_TO_AGENT",
    DO_NOT_CONTACT: "DO_NOT_CONTACT",
    // UNSERVICEABLE: "UNSERVICEABLE",
    // UNQUALIFIED: "UNQUALIFIED",
    // FUTURE_INTEREST: "FUTURE_INTEREST"
  },
  OPPORTUNITY_STATUSES: [
    {
      title: "Contact Not Established",
      value: "CONTACT_NOT_ESTABLISHED",
    },
    {
      title: "Contact Established",
      value: "CONTACT_ESTABLISHED",
    },
    {
      title: "Assigned to Agent",
      value: "ASSIGNED_TO_AGENT",
    },
    {
      title: "Closed",
      value: "CLOSED",
    },
    {
      title: "Removed Assignment to Agent",
      value: "REMOVED_ASSIGNMENT_TO_AGENT",
    },
    {
      title: "Do Not Contact",
      value: "DO_NOT_CONTACT",
    },
    {
      title: "Unserviceable",
      value: "UNSERVICEABLE",
    },
    {
      title: "Unqualified",
      value: "UNQUALIFIED",
    },
    {
      title: "Buyer",
      value: "FUTURE_INTEREST",
    },
    {
      title: "No Agent Accept",
      value: "NO_AGENT_ACCEPT",
    },
  ],
  OPPORTUNITY_TYPE: {
    BUYER: "BUYER",
    SELLER: "SELLER",
  },
  REFERRAL_TYPE: {
    BUYER: "BUYER",
    SELLER: "SELLER",
    RENTAL: "RENTAL",
  },
  REFERRAL_TYPES: [
    {
      title: "Buyer",
      value: "BUYER",
    },
    {
      title: "Seller",
      value: "SELLER",
    },
    {
      title: "Rental",
      value: "RENTAL",
    },
  ],
  FOLLOWUP_TYPES: [
    {
      title: "Overdue",
      value: "OVERDUE",
    },
    {
      title: "Up To Date",
      value: "UP_TO_DATE",
    },
  ],
  PRODUCT_FAMILY_TYPES: [
    {
      title: "PrimeStreet Referrals + IRIS",
      value: "COMBINED",
    },
    {
      title: "PrimeStreet Referrals",
      value: "PrimeStreet",
    },
    {
      title: "IRIS",
      value: "LeadGenius",
    },
  ],
  OPPORTUNITY_REMOVAL_REASONS: [
    {
      text: "Became unresponsive",
      value: "BECAME_UNRESPONSIVE",
    },
    {
      text: "No longer buying / selling",
      value: "NO_LONGER_BUYING",
    },
    {
      text: "Mortgage / Funding issues",
      value: "FUNDING",
    },
    {
      text: "Working with another agent",
      value: "WORKING_WITH_ANOTHER_AGENT",
    },
    {
      text: "Couldn't find home in budget",
      value: "NO_HOME_IN_BUDGET",
    },
    {
      text: "Outside my area",
      value: "DOES_NOT_WORK_AREA",
    },
    {
      text: "Duplicate referral",
      value: "DUPLICATE_REFERRAL",
    },
    {
      text: "Language barrier",
      value: "LANGUAGE_BARRIER",
    },
    {
      text: "I am no longer with brokerage",
      value: "NO_LONGER_WITH_BROKERAGE",
    },
    {
      text: "Transaction with an iBuyer",
      value: "TRANSACTION_WITH_IBUYER",
    },
  ],
  NOTIFICATION_TYPES: [
    {
      title: "Under Contract 1 Day Past",
      value: "UNDER_CONTRACT_1_DAY_PAST",
    },
    {
      title: "Overdue Referral Reminder",
      value: "OVERDUE_REFERRAL_REMINDER",
    },
    {
      title: "Long Term Hold",
      value: "LONG_TERM_HOLD",
    },
    {
      title: "New Referral",
      value: "NEW_REFERRAL",
    },
    {
      title: "Missed Referral",
      value: "MISSED_REFERRAL",
    },
    {
      title: "New Accepted Referral",
      value: "NEW_ACCEPTED_REFERRAL",
    },
    {
      title: "Force Assigned Referral",
      value: "FORCE_ASSIGNED_REFERRAL",
    },
    {
      title: "Test New Referral",
      value: "TEST_NEW_REFERRAL",
    },
  ],
  EVENT_BUS: {
    UPDATE_PASSWORD: "UPDATE_PASSWORD",
    OPPORTUNITY_DETAIL_CLOSED: "OPPORTUNITY_DETAIL_CLOSED",
    OPPORTUNITY_UPDATED: "OPPORTUNITY_UPDATED",
    OPPORTUNITY_REMOVED: "OPPORTUNITY_REMOVED",
    OPPORTUNITY_NOTE_POSTED: "OPPORTUNITY_NOTE_POSTED",
    USER_UPDATED: "USER_UPDATED",
    SUPPLIER_CREATED: "SUPPLIER_CREATED",
    RELOAD_SUPPLIERS: "RELOAD_SUPPLIERS",
    AGENT_UPDATED: "AGENT_UPDATED",
    BROKER_ADMIN_UPDATED: "BROKER_ADMIN_UPDATED",
    REFERRAL_UPDATED: "REFERRAL_UPDATED",
    AUDIO_PLAYED: "AUDIO_PLAYED",
    UI_TAB_SELECTED: "UI_TAB_SELECTED",
    SUPPLIER_ZIP_TAB_SELECTED: "SUPPLIER_ZIP_TAB_SELECTED",
    SUPPLIER_LIMITS_TAB_SELECTED: "SUPPLIER_LIMITS_TAB_SELECTED",
    DYNAMIC_CONTENT_UPDATED: "DYNAMIC_CONTENT_UPDATED",
    RELOAD_INVITED_AGENTS: "RELOAD_INVITED_AGENTS",
    RELOAD_DNC_LIST: "RELOAD_DNC_LIST",
    BROKERAGE_DETAIL_CLOSED: "BROKERAGE_DETAIL_CLOSED",
    AGENT_DETAIL_CLOSED: "AGENT_DETAIL_CLOSED",
    MY_AGENT_DETAIL_CLOSED: "MY_AGENT_DETAIL_CLOSED",
    SHOW_BROKER_BOOST_BANNER: "SHOW_BROKER_BOOST_BANNER",
    RELOAD_BOOST_STATUS: "RELOAD_BOOST_STATUS",
    DYNAMIC_CONTENT_NEED_RELOAD: "DYNAMIC_CONTENT_NEED_RELOAD",
    CLEAR_MARKETPLACE_NOTIFICATION_COUNT: "CLEAR_MARKETPLACE_NOTIFICATION",
  },
  STATES: [
    { AK: "Alaska" },
    { AL: "Alabama" },
    { AR: "Arkansas" },
    { AS: "American Samoa" },
    { AZ: "Arizona" },
    { CA: "California" },
    { CO: "Colorado" },
    { CT: "Connecticut" },
    { DC: "District of Columbia" },
    { DE: "Delaware" },
    { FL: "Florida" },
    { GA: "Georgia" },
    { GU: "Guam" },
    { HI: "Hawaii" },
    { IA: "Iowa" },
    { ID: "Idaho" },
    { IL: "Illinois" },
    { IN: "Indiana" },
    { KS: "Kansas" },
    { KY: "Kentucky" },
    { LA: "Louisiana" },
    { MA: "Massachusetts" },
    { MD: "Maryland" },
    { ME: "Maine" },
    { MI: "Michigan" },
    { MN: "Minnesota" },
    { MO: "Missouri" },
    { MS: "Mississippi" },
    { MT: "Montana" },
    { NC: "North Carolina" },
    { ND: "North Dakota" },
    { NE: "Nebraska" },
    { NH: "New Hampshire" },
    { NJ: "New Jersey" },
    { NM: "New Mexico" },
    { NV: "Nevada" },
    { NY: "New York" },
    { OH: "Ohio" },
    { OK: "Oklahoma" },
    { OR: "Oregon" },
    { PA: "Pennsylvania" },
    { PR: "Puerto Rico" },
    { RI: "Rhode Island" },
    { SC: "South Carolina" },
    { SD: "South Dakota" },
    { TN: "Tennessee" },
    { TX: "Texas" },
    { UT: "Utah" },
    { VA: "Virginia" },
    { VI: "Virgin Islands" },
    { VT: "Vermont" },
    { WA: "Washington" },
    { WI: "Wisconsin" },
    { WV: "West Virginia" },
    { WY: "Wyoming" },
  ],
  POTENTIAL_AGENT_STATUS_FILTER: [
    {
      title: "Enrolled",
      value: "ENROLLED",
    },
    {
      title: "Invite Pending",
      value: "INVITE_PENDING",
    },
    {
      title: "Invite Redeemed",
      value: "INVITE_REDEEMED",
    },
    {
      title: "Invite Declined",
      value: "INVITE_DECLINED",
    },
    {
      title: "Invite Invalidated",
      value: "INVITE_INVALIDATED",
    },
  ],
  BROKER_STATUS_FILTER: [
    {
      title: "Active",
      value: "ACTIVE",
    },
    {
      title: "Paused",
      value: "PAUSED",
    },
    {
      title: "Hidden",
      value: "HIDDEN",
    },
  ],
  AGENT_STATUS_FILTER: [
    {
      title: "Unsigned",
      value: "UNSIGNED",
    },
    {
      title: "Invited",
      value: "INVITED",
    },
    {
      title: "Active",
      value: "ACTIVE",
    },
    {
      title: "Paused",
      value: "PAUSED",
    },
    {
      title: "Deactivated",
      value: "DEACTIVATED",
    },
    {
      title: "Admin Hold",
      value: "ADMIN_HOLD",
    },
    {
      title: "In Training",
      value: "IN_TRAINING",
    },
    {
      title: "Deleted",
      value: "DELETED",
    },
  ],
  USER_ROLE_FILTER: [
    {
      title: "Admin",
      value: "ADMIN",
    },
    {
      title: "Brokerage Admin",
      value: "BROKERAGE_ADMIN",
    },
    {
      title: "Agent",
      value: "AGENT",
    },
    {
      title: "Manager",
      value: "MANAGER",
    },
    {
      title: "CSR Supervisor",
      value: "CSR_SUPERVISOR",
    },
    {
      title: "CSR",
      value: "CSR",
    },
    {
      title: "Agent Engagement",
      value: "AGENT_ENGAGEMENT",
    },
    {
      title: "QA Team",
      value: "QA_TEAM",
    },
  ],
  REFERRAL_STATUS_FILTER: [
    {
      title: "Awaiting Follow-up",
      value: "AWAITING_FOLLOWUP",
    },
    {
      title: "Closed",
      value: "CLOSED",
    },
    {
      title: "Offer Made",
      value: "OFFER_MADE",
    },
    {
      title: "Shown Homes",
      value: "SHOWN_HOMES",
    },
    {
      title: "Spoken With",
      value: "SPOKEN_WITH",
    },
    {
      title: "Under Contract",
      value: "UNDER_CONTRACT",
    },
    {
      title: "Removed",
      value: "REMOVED",
    },
    {
      title: "Long Term Hold",
      value: "LONG_TERM_HOLD",
    },
    {
      title: "Listed Home",
      value: "LISTED_HOME",
    },
    {
      title: "Met With Seller",
      value: "MET_WITH_SELLER",
    },
    {
      title: "Leased",
      value: "LEASED",
    },
  ],
  // added this array to align Agent Console statuses with the app.
  // we may be able to sync this across insights and remove the above or below array
  REFERRAL_STATUS_FILTER_APP: [
    {
      title: "Received",
      value: "AWAITING_FOLLOWUP",
    },
    {
      title: "Spoken With",
      value: "SPOKEN_WITH",
    },
    {
      title: "Met or Showed Homes",
      value: "SHOWN_HOMES",
    },
    {
      title: "Met With Seller",
      value: "MET_WITH_SELLER",
    },
    {
      title: "Made Offer",
      value: "OFFER_MADE",
    },
    {
      title: "Listed Home",
      value: "LISTED_HOME",
    },
    {
      title: "Under Contract",
      value: "UNDER_CONTRACT",
    },
    {
      title: "Closed",
      value: "CLOSED",
    },
    {
      title: "Leased",
      value: "LEASED",
    },
    {
      title: "Long-Term Hold",
      value: "LONG_TERM_HOLD",
    },
    {
      title: "Removed",
      value: "REMOVED",
    },
  ],
  REFERRAL_PROGRESSION_DUMMY_DATA: [
    {
      contact: {
        nameFirst: "Firstname",
        nameLast: "Lastname",
      },
      opportunity: {
        phoneCount: 2,
        smsCount: 77,
        status: "CONTACT_NOT_ESTABLISHED",
      },
    },
    {
      contact: {
        nameFirst: "Mike",
        nameLast: "Lastname",
      },
      opportunity: {
        phoneCount: 34,
        smsCount: 7,
        status: "CONTACT_ESTABLISHED",
      },
    },
    {
      contact: {
        nameFirst: "John",
        nameLast: "Developer",
      },
      opportunity: {
        phoneCount: 2,
        smsCount: 7,
        status: "ASSIGNED_TO_AGENT",
      },
    },
    {
      contact: {
        nameFirst: "Firstname",
        nameLast: "Lastname",
      },
      opportunity: {
        phoneCount: 345,
        smsCount: 7,
        status: "CLOSED",
      },
    },
  ],
  LEADS_BY_STATUS_DUMMY_DATA: [
    {
      count: 4,
      status: "CONTACT_NOT_ESTABLISHED",
      title: "Contact Not Established",
    },
    {
      count: 98,
      status: "CONTACT_ESTABLISHED",
      title: "Contact Established",
    },
    {
      count: 38,
      status: "ASSIGNED_TO_AGENT",
      title: "Assigned To Agent",
    },
    {
      count: 238,
      status: "CLOSED",
      title: "Closed",
    },
    {
      count: 43,
      status: "REMOVED_ASSIGNMENT_TO_AGENT",
      title: "Removed Assignment To Agent",
    },
    {
      count: 3,
      status: "DO_NOT_CONTACT",
      title: "Do Not Contact",
    },
    {
      count: 43,
      status: "UNSERVICEABLE",
      title: "Unserviceable",
    },
    {
      count: 3,
      status: "UNQUALIFIED",
      title: "Unqualified",
    },
  ],
  LEADS_BY_SOURCE_DUMMY_DATA: [
    {
      leadSuppliedCount: 83,
      supplierName: "example.com",
    },
    {
      leadSuppliedCount: 6,
      supplierName: "Zip-Foreclosures.com",
    },
    {
      leadSuppliedCount: 4,
      supplierName: "test.com",
    },
    {
      leadSuppliedCount: 29,
      supplierName: "example2.com",
    },
    {
      leadSuppliedCount: 78,
      supplierName: "cta-testing.com",
    },
    {
      leadSuppliedCount: 12,
      supplierName: "primestreet.io",
    },
    {
      leadSuppliedCount: 54,
      supplierName: "example34.com",
    },
    {
      leadSuppliedCount: 12,
      supplierName: "primestreet12.io",
    },
  ],
  LEADS_LIMITS_DUMMY_DATA: [
    { icon: "fas fa-envelope", title: "Leads Sent", count: 688 },
    { icon: "fas fa-copy", title: "Duplicates", count: 3 },
    { icon: "fas fa-chart-line", title: "Quarterly Cap", count: 9999 },
  ],
  PRICE_RANGES: [
    { title: "$100,000", value: 100000 },
    { title: "$130,000", value: 130000 },
    { title: "$150,000", value: 150000 },
    { title: "$200,000", value: 200000 },
    { title: "$250,000", value: 250000 },
    { title: "$300,000", value: 300000 },
    { title: "$350,000", value: 350000 },
    { title: "$400,000", value: 400000 },
    { title: "$450,000", value: 450000 },
    { title: "$500,000", value: 500000 },
    { title: "$550,000", value: 550000 },
    { title: "$600,000", value: 600000 },
    { title: "$650,000", value: 650000 },
    { title: "$700,000", value: 700000 },
    { title: "$750,000", value: 750000 },
    { title: "$800,000", value: 800000 },
    { title: "$850,000", value: 850000 },
    { title: "$900,000", value: 900000 },
    { title: "$950,000", value: 950000 },
    { title: "$1M", value: 1000000 },
    { title: "$1.1M", value: 1100000 },
    { title: "$1.2M", value: 1200000 },
    { title: "$1.3M", value: 1300000 },
    { title: "$1.4M", value: 1400000 },
    { title: "$1.5M", value: 1500000 },
    { title: "$1.6M", value: 1600000 },
    { title: "$1.7M", value: 1700000 },
    { title: "$1.8M", value: 1800000 },
    { title: "$1.9M", value: 1900000 },
    { title: "$2M", value: 2000000 },
    { title: "$2.25M", value: 2250000 },
    { title: "$2.5M", value: 2500000 },
    { title: "$2.75M", value: 2750000 },
    { title: "$3M", value: 3000000 },
    { title: "$3.5M", value: 3500000 },
    { title: "$4M", value: 4000000 },
    { title: "$5M", value: 5000000 },
    { title: "$10M", value: 10000000 },
    { title: "$20M", value: 20000000 },
  ],

  VALIDATION: {
    EMAIL:
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    PHONE: /^\+?\d{11}$/,
    PHONE_STRIPPED: /^\d{10}$/,
    ZIP: /^\d{5}$/,
  },
};

export default C;
